import { translateRoundPath, type RoundSlugAddress } from "@lib/roundSlugs";

export type ResolvedRoundRoute = { roundId: string; reference: string };

/** Format a stored ID-based link for the currently open round. Other links pass through. */
export function roundHref(
  path: string,
  route: ResolvedRoundRoute | null,
): string {
  if (!route) return path;
  return replaceReference(path, route.roundId, route.reference);
}

/** Give URL-parsing data helpers explicit identity from the resolved round. */
export function roundDataPath(
  path: string,
  route: ResolvedRoundRoute | null,
): string {
  if (!route) return path;
  return replaceReference(path, route.reference, route.roundId);
}

function replaceReference(path: string, from: string, to: string) {
  const prefix = `/round/${from}`;
  const rooted = path.startsWith("~/") ? path.slice(1) : path;
  if (
    !rooted.startsWith(prefix) ||
    !/^[/?#]?$/.test(rooted.slice(prefix.length, prefix.length + 1))
  )
    return path;
  return `${path.startsWith("~/") ? "~" : ""}/round/${to}${rooted.slice(prefix.length)}`;
}

/** Prefer a primary address for ID-based entry links; existing readable links stay intact. */
export function roundEntryHref(
  path: string,
  addresses: readonly RoundSlugAddress[],
): string {
  if (!/^~?\/round\/r-[^/?#]+(?=[/?#]|$)/.test(path)) return path;
  const rooted = path.startsWith("~/") ? path.slice(1) : path;
  return `${path.startsWith("~/") ? "~" : ""}${translateRoundPath(rooted, addresses, "slug")}`;
}
